import { colorPalette } from 'core/layouts/ui-blocks/ColorPalette';
import { tabletBreakpoint } from 'core/layouts/ui-blocks/ReusableStyles';

const tabletPadding = '10px';
const studioSideBarWidth = '232px';
const mobileHPadding = '16px';
const mobileVPadding = '40px';
const canvasSideBarWidth = '202px';
export const modalStyles = {
	modal: {
		backdropFilter: 'blur(2.5px)',
	},
	modalWrapper: {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		outline: 'none',
	},
	modalBody: {
		height: '100vh',
		width: '100vw',

		p: { xs: `${mobileVPadding} ${mobileHPadding}`, [tabletBreakpoint]: tabletPadding },

		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		position: 'relative',
	},
	modalContent: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexDirection: 'column',
		position: 'relative',
		borderRadius: '8px',
		overflow: 'hidden',
		gap: '16px',
		backgroundColor: 'colors.dark6',
		border: `1px solid ${colorPalette.dark1}`,
	},
	contentWrapperTextToImageStyles: {
		width: {
			xs: `calc(100vw - calc(${mobileHPadding} * 2))`,
			[tabletBreakpoint]: `calc(100vw - calc(${studioSideBarWidth} * 2))`,
		},
	},
	contentWrapperCanvasStyles: {
		width: {
			xs: `calc(100vw - calc(${mobileHPadding} * 2))`,
			[tabletBreakpoint]: `calc(100vw - calc(${canvasSideBarWidth} * 2))`,
		},
		left: '0px',
	},
	contentWrapper: {
		height: '80vh',
		overflow: { xs: 'hidden', [tabletBreakpoint]: 'hidden' },
	},
	modalHeaderWrapper: {
		padding: '20px',
		borderBottom: `1px solid ${colorPalette.dark1}`,
		backgroundColor: 'colors.dark5',
	},
	modalHeader: {
		width: '100%',
		justifyContent: 'space-between',
	},
	closeButton: {
		position: 'absolute',
		right: 0,
		top: 0,
		height: {
			xs: '30px',
			[tabletBreakpoint]: '40px',
		},
		width: {
			xs: '30px',
			[tabletBreakpoint]: '40px',
		},
		display: 'flex',
		alignContent: 'center',
		flexWrap: 'wrap',
		justifyContent: 'center',

		backgroundColor: 'colors.dark3',
		borderRadius: '50%',
		border: `1px solid ${colorPalette.dark1}`,
		'& svg': {
			width: {
				xs: 16,
				[tabletBreakpoint]: 24,
			},
			height: {
				xs: 16,
				[tabletBreakpoint]: 24,
			},
			color: 'colors.light3',
		},
		'&:hover': {
			backgroundColor: 'colors.dark4',
		},

		zIndex: '3',
		cursor: 'pointer',
	},
};
